import React, { useState, useEffect } from "react"
import dayjs from "dayjs"
import { cn } from "lib/utils"
import SectionHeaderRender from "lib/units/element/SectionHeader/SectionHeaderRender"
import { useRenderStyling, renderStyle } from "lib/hooks/useRenderStyling"
import { getApiFeedData, parseContent, parseSingleContent } from "./utils"
import { usePrepForRender, useDataCollector } from "lib/hooks"

export default function TrxHistoryTableRender({ renderPkg }:{ renderPkg?:any }){

  const [ dataStructure, setDataStructure ] = useState<any>(null)
  const [ currentElement, setCurrentElement ] = useState<any>(null)
  const [ contentToRender, setContentToRender ] = useState<any>(null)
  const [ columnsToRender, setColumnsToRender ] = useState<any>([])

  const { prepDataForRender } = useDataCollector()

  const outerStyling = useRenderStyling("mm-section flex flex-col", "styleObj")
  const outerTableStyling = useRenderStyling("w-full mt-2 mb-4 ml-4", "styleObj")
  // const tableStyling = useRenderStyling("min-w-[980px] w-full text-sm border-separate", "styleObj")
  // const headerStyling = renderStyle(cn("border-b border-solid border-b-black" ), "styleObj")
  // const rowStyling = useRenderStyling("border-b border-solid border-neutral-700", "styleObj")


  const allowedTypes = ['sale', 'refund', 'capture']

  useEffect(() => {
    if( renderPkg ){
      const elemStructure = renderPkg.elements.find( (elem:any) => elem.refstr === "trx_history" )?.config?.structure || []

      let newData = renderPkg.clientdata.rp.AdditionalTransactions?.filter( (item:any) => allowedTypes.includes(item.TransactionDetails.ActionType)).map( (item:any, idx:number) => {
        const data = prepDataForRender("trx_history", item.TransactionDetails, elemStructure, renderPkg, "object", idx)
        return data
      })

      const columns = Object.keys(newData[0]).filter( (item:any) => newData[0][item].okToRender !== false)
      const filteredContent = newData.filter( (item:any) => item.okToRender !== false )
      setContentToRender(filteredContent)
      setColumnsToRender(columns)
    }
  },[renderPkg])

  useEffect(() => {
    if( !currentElement ) {
      const elem = renderPkg.elements.find( (elem:any) => elem.refstr === "trx_history" )
      if( elem ) setCurrentElement(elem)
    }
  },[renderPkg, currentElement])

  if( !currentElement || !contentToRender?.length ) return <></>
  return (
    <div id="mm-trx-history" {...outerStyling}>
      
      <SectionHeaderRender title="Transaction History" />

      <div {...outerTableStyling}>
        <table style={{
          minWidth: "980px",
          maxWidth: "1050px",
          // width: "100%",
          borderCollapse: "separate",
          border: "1px solid #000",
          borderSpacing: "0px",
          fontSize: "0.875rem", // 14px
          color: "#000000"
        }}>
          <thead>
            <tr>
              { columnsToRender.map( (column:any, idx:number) => {
                const headerStyling = renderStyle(cn("text-sm align-bottom text-left font-bold pl-1 pr-3 leading-tight" ), "styleObj")
                return (
                  <th key={idx} style={{ textAlign: "left", paddingLeft: "2px", paddingRight: "4px", borderBottom: "1px solid #000" }}>
                    {contentToRender[0][column].label}
                  </th>
                )
              }
              )}
            </tr>
          </thead>
          <tbody>
            { contentToRender
              .map( (trxObj:any, idx1:number) => (
                <tr 
                  key={`row-${idx1}`}
                >
                { columnsToRender.map( (column:any, idx2:number) => { 
                  const dataStyling = 
                    renderStyle(cn(
                      "text-left text-sm align-top pl-1 pr-3 pt-0.5 pb-0.5",
                      (column === "merchantref" || column.prop === "trxid") ? "break-word" : "",
                      column.width 
                    ), "styleObj")
                  return (
                    <td 
                      key={`col-${idx2}`}
                      style={{
                        textAlign: "left",
                        paddingLeft: "2px",
                        paddingRight: "4px",
                        paddingTop: "2px",
                        paddingBottom: "2px",
                        borderBottom: "1px solid #000"
                      }}
                    >
                      { trxObj[column].value }
                    </td>
                  )
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}